import { render, staticRenderFns } from "./UpscaleRegionCard.vue?vue&type=template&id=bf4c6748&scoped=true"
import script from "./UpscaleRegionCard.vue?vue&type=script&lang=js"
export * from "./UpscaleRegionCard.vue?vue&type=script&lang=js"
import style0 from "./UpscaleRegionCard.vue?vue&type=style&index=0&id=bf4c6748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4c6748",
  null
  
)

export default component.exports